import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/poshmark-photo-editing-apps';

export default function Example() {
  return (
    <>
      <Head>
        <title>The 8 Best Photo Editing Apps for Poshmark</title>
        <meta
          name='description'
          content='Poshmark limits the number of photos per listings, so catch the attention to grow your Poshmark sales!'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/poshmark-photo-editing-apps' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/poshmark-photo-editing-apps' />
        <meta property='og:title' content='The 8 Best Photo Editing Apps for Poshmark' />
        <meta
          property='og:description'
          content='Poshmark limits the number of photos per listings, so catch the attention to grow your Poshmark sales!'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=4' />
        <meta property='article:published_time' content='2022-01-22T00:00:00.000Z' />
        <meta property='article:modified_time' content='2022-01-22T00:00:00.000Z' />
        <meta property='article:tag' content='Crosslisting' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
